const en = {
    views: {
        home: {
            addTask: 'Add task',
            modalName: 'Name',
            modalDescription: 'Description',
            modalTitle: 'Add task',
            modalCancel: 'Cancel',
            modalSave: 'Save',
            successAdd: 'Added todo',
            successRemove: 'Removed todo',
        },
    },
    common: {
        titles: {
            tasks: 'My tasks',
            personalData: 'My data',
            personalReturns: 'My returns',
        },
        languages: {
            title: 'Language',
        },
        errors: {
            removeTodo: 'Error removing todo',
            addTodo: 'Error adding todo',
        },
    },
};

export default en;
